import { useHelpCenter } from '@/HelpCenter/ui/context/HelpCenterContext'
import { OreButton, OreStack } from '@edenredespana/oreneta'
import {
    TicketDetailFooterReOpen,
    TicketDetailFooterClosed,
} from '@/HelpCenter/ui/atoms'
import { TicketStatus } from '@/HelpCenter/domain/TicketModel'
import { navigationRoutes } from "@/Shared/ui/routers"
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'

export const TicketDetailFooter = (): JSX.Element => {
    const { ticketDetail } = useHelpCenter()
    const navigate = useNavigate()
    const { t } = useTranslation()

    return (
        <OreStack
            space="medium"
            placeContent="center"
            style={{
                minWidth: '100%',
            }}>
            <>
                {ticketDetail?.statusOneforce === TicketStatus.InProgress ? (
                    <OreButton 
                    category='primary'
                    onClick={() => navigate(navigationRoutes.myTickets)}
                    >
                       {t(HelpCenterTranslations.ticketDetail.footer.understandButton)}
                    </OreButton>) :
                    (<>
                        {ticketDetail?.canReopen ? (
                            <TicketDetailFooterReOpen />
                        ) : (
                            <TicketDetailFooterClosed />
                        )}
                    </>)}
            </>
        </OreStack>
    )
}


